import React, { useEffect } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import { Alert, Pagination } from "@material-ui/lab";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { SearchButton } from "components/searchButton";
import { Wrapper } from "components/wrapper";
import CustomBackdrop from "components/backdrop";
import { UltimaAtualizacao } from "components/ultimaAtualizacao";
import { ExportButtons } from "components/exportButtons";
import { SortDirectionSelect } from "components/sortDirectionSelect";
import { useContratosState } from "./context/contratos-context";
import { useContratosController } from "./context/contratos-controller";
import { ContratosTable } from "./contratosTable.component";

export function ContratosPage() {
  const { contratos, contratoPagedRequest, loading, tipos, situacoes, ultimaAtualizacao, error } = useContratosState();
  const { onInit, handleOnChange, listContratos, exportContratos } = useContratosController();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await listContratos({ ...contratoPagedRequest, page: value - 1 }, true);
    })();
  };

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Contratos" },
        ]}
      />
      <PageTitle>Contratos</PageTitle>
      <Wrapper>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="text-field-term"
                  label="Número ou objeto"
                  value={contratoPagedRequest?.term || ''}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel shrink>Tipo</InputLabel>
                  <Select
                    name="select-tipo-id"
                    value={contratoPagedRequest?.idTipoContrato || ''}
                    onChange={(e) => handleOnChange(e)}
                    label="Tipo"
                    displayEmpty
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {tipos?.map((t) => (
                      <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel shrink>Situação</InputLabel>
                  <Select
                    name="select-situacao-id"
                    value={contratoPagedRequest?.idSituacaoContrato || ''}
                    onChange={(e) => handleOnChange(e)}
                    label="Situação"
                    displayEmpty
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {situacoes?.map((s) => (
                      <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                <SearchButton onClick={() => (async () => {
                  await listContratos(contratoPagedRequest, true);
                })()}>
                  <SearchIcon /> Consultar
                </SearchButton>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="date"
                  name="date-field-inicio"
                  label="Data início"
                  value={contratoPagedRequest?.dataInicio || ''}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="date"
                  name="date-field-fim"
                  label="Data fim"
                  value={contratoPagedRequest?.dataFim || ''}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <SortDirectionSelect
                  value={contratoPagedRequest?.orderDirection}
                  onChange={(e) => handleOnChange(e)}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            <UltimaAtualizacao data={ultimaAtualizacao} />
            <ExportButtons onExport={exportContratos} />
            {error ? (
              <Alert severity="error">{error}</Alert>
            ) : (
              <ContratosTable currentItems={contratos} />
            )}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3} justifyContent="center">
              <Pagination
                size="large"
                variant="outlined"
                shape="rounded"
                onChange={handlePageClick}
                count={contratos?.pageCount}
                color="primary"
              />
            </Grid>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
}
